export var NODE_IS_VISIBLE = true;
export var NODE_IS_NOT_VISIBLE = false;